(function () {
  'use strict';

  /**
   * Hide a badge element if its numeric count is 0 or empty.
   * Restores visibility when count > 0.
   */
  function syncBadge(el) {
    if (!el) return;
    var count = parseInt(el.textContent.trim(), 10);
    if (!count || count <= 0) {
      el.style.setProperty('display', 'none', 'important');
    } else {
      // Only restore if it was hidden by us (not by Growave's own display:none)
      if (el.style.display === 'none' && !el.hasAttribute('data-growave-hidden')) {
        el.style.removeProperty('display');
      } else if (!el.hasAttribute('data-growave-hidden')) {
        el.style.removeProperty('display');
      }
    }
  }

  function refreshAllBadges() {
    document.querySelectorAll(
      '.m-header .m-cart-count, .m-header .m-wishlist-count, .m-header .ssw-counter-fave-menu'
    ).forEach(syncBadge);
  }

  // Run once DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAllBadges);
  } else {
    refreshAllBadges();
  }

  // Re-run after a short delay to catch Growave initialisation
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(refreshAllBadges, 500);
    setTimeout(refreshAllBadges, 1500);
  });

  // Watch badge elements for text/attribute changes (AJAX cart & Growave updates)
  document.addEventListener('DOMContentLoaded', function () {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.target && m.target.matches) {
          if (m.target.matches(
            '.m-cart-count, .m-wishlist-count, .ssw-counter-fave-menu'
          )) {
            syncBadge(m.target);
          }
        }
        // Also check if a child text node changed
        if (m.target && m.target.parentElement) {
          var parent = m.target.parentElement;
          if (parent.matches &&
            parent.matches('.m-cart-count, .m-wishlist-count, .ssw-counter-fave-menu')
          ) {
            syncBadge(parent);
          }
        }
      });
    });

    document.querySelectorAll(
      '.m-cart-count, .m-wishlist-count, .ssw-counter-fave-menu'
    ).forEach(function (el) {
      observer.observe(el, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
      });
    });
  });

  // Listen for common theme & app cart/wishlist update events
  [
    'cart:updated',
    'cart:refresh',
    'cart:build',
    'wishlist:updated',
    'wishlist:add',
    'wishlist:remove',
    'growave:wishlist:updated',
    'growave:initialized'
  ].forEach(function (evt) {
    document.addEventListener(evt, refreshAllBadges);
  });

})();
